/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompetitionLeagueUpdate
 */
export interface CompetitionLeagueUpdate {
    /**
     * 
     * @type {string}
     * @memberof CompetitionLeagueUpdate
     */
    name?: string | null;
}

/**
 * Check if a given object implements the CompetitionLeagueUpdate interface.
 */
export function instanceOfCompetitionLeagueUpdate(value: object): value is CompetitionLeagueUpdate {
    return true;
}

export function CompetitionLeagueUpdateFromJSON(json: any): CompetitionLeagueUpdate {
    return CompetitionLeagueUpdateFromJSONTyped(json, false);
}

export function CompetitionLeagueUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompetitionLeagueUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function CompetitionLeagueUpdateToJSON(json: any): CompetitionLeagueUpdate {
    return CompetitionLeagueUpdateToJSONTyped(json, false);
}

export function CompetitionLeagueUpdateToJSONTyped(value?: CompetitionLeagueUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
    };
}

